import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["name"]
  }

  static get values() {
    return {
      version: { type: String, default: "domain_search" },
      domain: String,
    }
  }

  connect() {
    this.element.addEventListener("submit", function (event) {
      event.preventDefault()
    })
  }

  find() {
    let targetFrame = document.getElementById("domain_search_email_finder_email")
    targetFrame.src = App.api.findEmail(this.domainValue, this.nameTarget.value, "html", this.versionValue)
    targetFrame.reload()
    targetFrame.loaded.then(() => {
      if (document.getElementById("ds-no-result")) {
        this.dispatch("loaded", { detail: { count: 0 } })
      } else {
        this.dispatch("loaded", { detail: { count: 1 } })
      }

      document.getElementById("company-emails-filters").classList.add("d-none")
    })
  }
}
